export default __webpack_public_path__ + "static/media/11.227c3e2d.png";